import clsx from 'clsx';
import { useEffect } from 'react';

import { StatTile } from '@/components/StatTile/StatTile';
import { useInvoice } from '@/store/expenses-store/invoices/invoices.store.ts';
import { formatCurrency } from '@/utils/formatCurrency.ts';
import { useInvoicesToPay } from '@pages/Manage/useManageFinance';

import styles from './InvoicesToPayWidget.module.scss';

const DOT_CLASS = {
  overdue: styles.dotDanger,
  unpaid: styles.dotWarn,
  clear: styles.dotOk,
};

export const InvoicesToPayWidget = () => {
  const getInvoices = useInvoice((state) => state.getInvoices);
  const loading = useInvoice((state) => state.loading);
  const { state, total, sublabel } = useInvoicesToPay();

  useEffect(() => {
    void getInvoices();
  }, [getInvoices]);

  return (
    <StatTile
      label="Invoices to Pay"
      large
      value={loading ? undefined : state === 'clear' ? 'None' : `$${formatCurrency(total)}`}
      sublabel={sublabel}
      className={state === 'overdue' ? styles.tileDanger : undefined}
      icon={<span className={clsx(styles.dot, DOT_CLASS[state])} aria-hidden="true" />}
      to="/manage/invoices?filter=unpaid"
    />
  );
};

export default InvoicesToPayWidget;
